// eslint-disable-next-line
import React, { useState } from "react";
import './Header.scss'
function Header() {
  const storedUser = localStorage.getItem("user")
  const [user, setUser] = useState(JSON.parse(storedUser));

  const handleClickLogin = () =>{
    window.location.href = '/login/email';
  }

  const handleClickProfile = () =>{
    window.location.href = '/profile/info';
  }

  return (
    <>
      <nav className="fv-navbar svelte-vanno8" data-testid="navbar">
        <div className="fv-navbar--wrapper svelte-vanno8">
          <div className="fv-navbar__logo-container svelte-vanno8">
            <div className="fv-navbar__logo-light svelte-vanno8">
              <div className="header-logo header-logo--fever svelte-c80kyr">
                <a
                  data-testid="header-logo__link"
                  aria-label="Logo"
                  href="/"
                >
                  <div data-testid="header-logo__picture">
                    <img
                      className="logo logo--fever svelte-c80kyr"
                      src="https://logos-world.net/wp-content/uploads/2020/10/Free-Logo.png"
                      loading="lazy"
                    />
                  </div>
                </a>
              </div>
            </div>
            <div className="fv-navbar__logo-dark svelte-vanno8">
              <div className="header-logo header-logo--fever svelte-c80kyr">
                <a
                  data-testid="header-logo__link"
                  aria-label="Fever"
                  href="/de/berlin"
                >
                  <div data-testid="header-logo__picture">
                    <img
                      className="logo logo--fever svelte-c80kyr"
                      src="/logo/fever-logo-black.svg"
                      loading="lazy"
                      alt="Fever logo"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <ul className="fv-navbar__tools svelte-vanno8 fv-navbar__tools--search">
            {/* Search Bar */}
            <li className="fv-navbar__search-link svelte-vanno8">
              <div className="mobile svelte-vanno8">
                <a
                  className="fv-navbar__link svelte-vanno8"
                  aria-label="helpCenter.searchInputPlaceholder"
                  data-testid="navbar-search-btn"
                  href="/de/berlin/search-list"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    aria-hidden="true"
                    focusable="false"
                    className="svg-inline--fa fa-magnifying-glass search-icon svelte-1ipid5s"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="currentColor"
                      d="M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"
                    ></path>
                  </svg>
                </a>
              </div>
              <div
                className="fv-navbar__search desktop svelte-vanno8"
                data-testid="navbar-search-container"
              >
                <div className="search-typeahead svelte-1jcgsle">
                  <div className="search-typeahead__box svelte-1jcgsle">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-hidden="true"
                      focusable="false"
                      className="svg-inline--fa fa-magnifying-glass search-typeahead__search-icon svelte-1ipid5s"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"
                      ></path>
                    </svg>
                    <input
                      className="search-typeahead__box__input svelte-1jcgsle"
                      type="search"
                      data-testid="search-typeahead-input"
                    />
                    <div className="search-typeahead__placeholder svelte-1ywtld9">
                      <span className="search-typeahead__placeholder-static svelte-1ywtld9">
                        Bạn đang tìm gì ?
                      </span>
                      <div className="search-typeahead__dynamic-cta svelte-1jeq7oa">
                      </div>
                    </div>
                  </div>{" "}
                  <a
                    className="search-typeahead__link svelte-1jcgsle"
                    data-testid="search-typeahead__link"
                    href="/de/berlin/search-list"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-hidden="true"
                      focusable="false"
                      className="svg-inline--fa fa-magnifying-glass search-typeahead__search-icon svelte-1ipid5s"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"
                      ></path>
                    </svg>
                  </a>
                </div>
              </div>
            </li>
            {/* <li className="svelte-vanno8 fv-navbar__language-selector">
              <button
                className="language-selector-button svelte-1xyxljg"
                data-testid="navbar-language-selector-btn"
                aria-label="Sprache auswählen"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-hidden="true"
                  focusable="false"
                  className="svg-inline--fa fa-globe language-icon svelte-1ipid5s"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M256 480c16.7 0 40.4-14.4 61.9-57.3c9.9-19.8 18.2-43.7 24.1-70.7H170c5.9 27 14.2 50.9 24.1 70.7C215.6 465.6 239.3 480 256 480zM164.3 320H347.7c2.8-20.2 4.3-41.7 4.3-64s-1.5-43.8-4.3-64H164.3c-2.8 20.2-4.3 41.7-4.3 64s1.5 43.8 4.3 64zM170 160H342c-5.9-27-14.2-50.9-24.1-70.7C296.4 46.4 272.7 32 256 32s-40.4 14.4-61.9 57.3C184.2 109.1 175.9 133 170 160zm210 32c2.6 20.5 4 41.9 4 64s-1.4 43.5-4 64h90.8c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64H380zm78.5-32c-25.9-54.5-73.1-96.9-130.9-116.3c21 28.3 37.6 68.8 47.2 116.3h83.8zm-321.1 0c9.6-47.6 26.2-88 47.2-116.3C126.7 63.1 79.4 105.5 53.6 160h83.7zm-96 32c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64H132c-2.6-20.5-4-41.9-4-64s1.4-43.5 4-64H41.3zM327.5 468.3c57.8-19.5 105-61.8 130.9-116.3H374.7c-9.6 47.6-26.2 88-47.2 116.3zm-143 0c-21-28.3-37.5-68.8-47.2-116.3H53.6c25.9 54.5 73.1 96.9 130.9 116.3zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z"
                  ></path>
                </svg>{" "}
                <span className="language-selector-button-text svelte-1xyxljg">
                  de
                </span>
              </button>
              <div
                className="fv-language-selector svelte-huzi8c"
                data-testid="language-selector"
              >
                <span className="fv-language-selector__language fv-language-selector__language--selected svelte-huzi8c">
                  Deutsch
                </span>
                <a
                  className="fv-language-selector__language svelte-huzi8c"
                  href="/m/192454/en"
                >
                  English
                </a>
              </div>
            </li> */}
            <li className="fv-navbar__divider desktop svelte-vanno8" />
            {/* Location */}
            <li className="mobile svelte-vanno8">
              <button
                className="fv-city-selector-button svelte-1f3czt0 fv-city-selector-button__icon-mode"
                data-city-selector-open=""
                data-city-selector-source="navbar"
                aria-label="Wähle deine Stadt"
              >
                <span className="fv-city-selector-button__location-icon svelte-1f3czt0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    aria-hidden="true"
                    focusable="false"
                    className="svg-inline--fa fa-location-dot fa-full svelte-1ipid5s"
                    viewBox="0 0 384 512"
                  >
                    <path
                      fill="currentColor"
                      d="M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"
                    ></path>
                  </svg>
                </span>{" "}
              </button>
            </li>
            {/* User */}
            {
              user ? (
                <>
                  <li className="svelte-vanno8">
                    <button
                      data-testid="user-profile-btn"
                      aria-label="Mein Konto"
                      className="fv-login svelte-ef1xps"
                      onClick={()=>handleClickProfile()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        aria-hidden="true"
                        focusable="false"
                        className="svg-inline--fa fa-circle-user fv-login__user svelte-1ipid5s"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M412.1 416.6C398.1 361.1 347.9 320 288 320H224c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.5 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1h64c50.4 0 91.6 38.8 95.7 88.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"
                        ></path>
                      </svg>
                    </button>{" "}
                  </li>
                </>
              ) : (<>
                <li className="svelte-vanno8">
                  <button
                    onClick={()=>handleClickLogin()}
                    className="fv-city-selector-button svelte-1f3czt0 fv-city-selector-button__icon-mode"
                    data-testid="user-profile-btn"
                    aria-label="Mein Konto"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-hidden="true"
                      focusable="false"
                      className="svg-inline--fa fa-circle-user fv-login__user svelte-1ipid5s"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M412.1 416.6C398.1 361.1 347.9 320 288 320H224c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.5 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1h64c50.4 0 91.6 38.8 95.7 88.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"
                      ></path>
                    </svg>
                  </button>{" "}
                </li>
              </>)
            }
            {/* Details */}
            <li className="mobile svelte-vanno8">
              <button
                data-testid="navbar-toggle"
                className="fv-navbar__toggle svelte-vanno8"
                type="button"
                aria-label="Toggle navigation"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-hidden="true"
                  focusable="false"
                  className="svg-inline--fa fa-bars fa-fw toggle-icon svelte-1ipid5s"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16z"
                  ></path>
                </svg>
              </button>
            </li>
          </ul>
        </div>
      </nav>
    </>
  )
}
export default Header;